import * as yup from 'common/yup';
import {enums} from 'types/enums';

export const ReportRelativeTimeRangeTypeNames = {
   relativeDate: 'relativeDate',
   relativeDateType: 'relativeDateType',
} as const;

export const ReportRelativeTimeRangeType = yup.object({
   [ReportRelativeTimeRangeTypeNames.relativeDate]: yup.bool(),
   [ReportRelativeTimeRangeTypeNames.relativeDateType]: yup
      .string()
      .when(ReportRelativeTimeRangeTypeNames.relativeDate, {
         is: true,
         then: (schema: yup.StringSchema<string>) => schema.oneOf(enums.TimeRangeReportType.keys),
         otherwise: (schema: yup.StringSchema<string>) => schema,
      })
      .default(enums.TimeRangeReportType.enum.TODAY),
});
